import { useSearchParams } from 'react-router-dom';
import { useCallback } from 'react';

export function useUrlParams() {
  const [searchParams, setSearchParams] = useSearchParams();

  const get = useCallback((key, defaultValue) => {
    const raw = searchParams.get(key);
    if (raw === null) return defaultValue;
    if (typeof defaultValue === 'number') {
      const parsed = Number(raw);
      return Number.isNaN(parsed) ? defaultValue : parsed;
    }
    return raw;
  }, [searchParams]);

  const set = useCallback((updates) => {
    setSearchParams(prev => {
      const next = new URLSearchParams(prev);
      for (const [key, value] of Object.entries(updates)) {
        if (value === null || value === undefined || value === '') next.delete(key);
        else next.set(key, String(value));
      }
      return next;
    }, { replace: true });
  }, [setSearchParams]);

  return { get, set };
}
